import { HomeOutlined, ListAlt, Settings } from "@mui/icons-material";
import { Tab, Tabs } from "@mui/material";
import { usePath } from "../libs/path/PathProvider";
import FoodUtils, { Pages } from "../utils/FoodUtils";

export default function(){
    const {path,setPath} = usePath()
    const tab = FoodUtils.currentPage(path).tab

    const icons = [<HomeOutlined/>, <ListAlt/>, <Settings/>]
    const tabs = Pages.map(tab => {
        return <Tab label={tab.label} icon={icons[tab.tab]} onClick={e => setPath("/"+tab.value)} key={tab.value}/>
    })
    return <footer>
        <Tabs value={tab} variant="fullWidth">{tabs}</Tabs>
    </footer>
}